<p class="subtitle is-1">{{ ('terms-conditions') | translate }}</p>
